import {HttpClient} from "@angular/common/http";
import {Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {environment} from "@env/environment";
import {IStoreState} from "../store/store.state";
import {AuthLogoutAction} from '@modules/users/store/user.actions';
import {LoginResponse} from "@core/model/servicesResponse";
import {User, UserResponse} from "@modules/users/users.interface";
import {LOGSEVERITY, LOGTYPE} from "@core/app.costants";
import {ErrorService} from "@services/error.service";
import {WatchdogService} from "@services/watchdog.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
    private http: HttpClient,
    private store: Store<IStoreState>,
    private errorService: ErrorService,
    private watchdog: WatchdogService
  ) { }

  login(email: string, password: string): Observable<LoginResponse> {
    let request = { 'email': email, 'password': password };
    return this.http.post<LoginResponse>(`${environment.DASHBOARD_PUBLIC_BASE_URL}/autenticaUtente`, request);
  }

  logout() {
    const errorMessage = "Logout effettuato con successo.";
    this.errorService.setError(errorMessage);

    this.watchdog.writeWatchdog({
      type: LOGTYPE.INFO,
      severity: LOGSEVERITY.NONE,
      message: "L'utente ha effettuato il logout",
    });

    this.store.dispatch(AuthLogoutAction());
  }

  checkUser(email: string): Observable<User> {
    return this.http.post<UserResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/cercaUtente`, {email: email}).pipe(
      map(response => {
        if (response.status?.codice !== '000') {
          const errorMessage = "Non è stato possibile trovare l'utente.";
          this.errorService.setError(errorMessage);
        }
        return response.data.utente;
      })
    )
  }
}
